import React, { useRef, useState } from 'react';
import { IconButton } from '@mui/material';
import { Search, X } from 'lucide-react';
import useDebouncedEffect from '../../hooks/useDebouncedEffect';
import CustomInput from '../CustomInput/CustomInput';

interface SearchBarProps {
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  searchTermFromState?: string;
  placeholder?: string;
}

function SearchBar({
  setQuery,
  searchTermFromState,
  placeholder
}: SearchBarProps): React.ReactElement {
  const [searchTerm, setSearchTerm] = useState<string>(
    searchTermFromState || ''
  );
  const immediateActionRef = useRef(false);

  const didMount = useRef(false);

  const handleClearSearch = (): void => {
    immediateActionRef.current = true;
    setSearchTerm('');
    setQuery('');
  };

  const handleChangeSearch = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSearchTerm(event.target.value);
  };

  useDebouncedEffect(
    () => {
      if (!didMount.current) {
        didMount.current = true;
        return;
      }
      if (immediateActionRef.current) {
        immediateActionRef.current = false;
        return;
      }
      setQuery(searchTerm);
    },
    [searchTerm],
    500
  );

  return (
    <CustomInput
      placeholder={placeholder}
      type='text'
      name='search'
      value={searchTerm}
      onChange={handleChangeSearch}
      onBlur={() => {}}
      autoComplete='on'
      prefix={<Search size={18} />}
      suffix={
        searchTerm ? (
          <IconButton
            aria-label='Clear search'
            onClick={handleClearSearch}
            size='small'
            className='text-gray-500 hover:text-gray-700'
          >
            <X size={18} />
          </IconButton>
        ) : null
      }
      containerClassName='mb-0'
    />
  );
}

export default SearchBar;
